import { COLORS } from '@btime/constants'
import { compose, join, paths } from 'ramda'
import { usePageTitle } from '@btime/react-hooks'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePermalinkNavigation } from '../../../utils/routes/permalinkNavigation'
import { usePrintPdf } from '../../../components/pdf/options/_helpers/printPdf'
import { useServiceOrder } from '../resumeV2/_load/ServiceOrderLoader'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import { useQueryParams } from '../../../utils/contexts/UrlProvider'

const PageHeader = () => {
  const serviceOrder = useServiceOrder()
  const { t } = useTranslation()
  const navigate = usePermalinkNavigation()
  const title = compose(join(' - '), paths([['yearlyId'], ['checklist', 'name']]))(serviceOrder)
  const [loading, print] = usePrintPdf(title)
  const { autoPrint } = useQueryParams()

  usePageTitle(title)

  React.useEffect(() => {
    if (!!autoPrint) print()
  }, [autoPrint])

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={
        <Link onClick={print} block loading={loading} loadingColor={COLORS.white} loadingBgColor={COLORS.purple}>
          <IconText
            iconSize="1.4rem"
            weight="700"
            iconName="BsFileEarmarkBreak"
            color={COLORS.white}
            label={t('print')}
          />
        </Link>
      }
    />
  )
}

export default PageHeader
